module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return warning; });
/* unused harmony export unreachable */
/* harmony export (immutable) */ __webpack_exports__["k"] = onlyOnLeftClick;
/* unused harmony export noop */
/* harmony export (immutable) */ __webpack_exports__["g"] = identity;
/* harmony export (immutable) */ __webpack_exports__["b"] = constant;
/* harmony export (immutable) */ __webpack_exports__["h"] = isPromise;
/* harmony export (immutable) */ __webpack_exports__["j"] = once;
/* harmony export (immutable) */ __webpack_exports__["c"] = createEmptyObjectWithoutPrototype;
/* harmony export (immutable) */ __webpack_exports__["d"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
/* harmony export (immutable) */ __webpack_exports__["e"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["i"] = last;
/* harmony export (immutable) */ __webpack_exports__["f"] = find;
/* harmony export (immutable) */ __webpack_exports__["m"] = removeFromArray;
/* harmony export (immutable) */ __webpack_exports__["l"] = quickDiff;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var warning = process.env.NODE_ENV === 'production' ? noop : function warning(checker, complainer) {
  if (!checker()) {
    var _console;

    var message = ['[Vue-Treeselect Warning]'].concat(complainer());

    (_console = console).error.apply(_console, _toConsumableArray(message));

    debugger;
  }
};

var unreachable = process.env.NODE_ENV === 'production' ? noop : function unreachable() {
  console.error('[Vue-Treeselect Error] You should not reach here.');

  debugger;
};

function onlyOnLeftClick(mouseDownHandler) {
  return function onMouseDown(evt) {
    if (evt.type === 'mousedown' && evt.button === 0) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      mouseDownHandler.call.apply(mouseDownHandler, [this, evt].concat(args));
    }
  };
}

function noop() {}

function identity(x) {
  return x;
}

function constant(x) {
  return function () {
    return x;
  };
}

function isPromise(x) {
  return x != null && ((typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' || typeof x === 'function') && typeof x.then === 'function';
}

function once(fn) {
  var val = void 0;
  return function () {
    if (fn.called) return val;
    fn.called = true;
    return val = fn.apply(undefined, arguments);
  };
}

function createEmptyObjectWithoutPrototype() {
  return Object.create(null);
}

function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

  var timeout = void 0,
      args = void 0,
      context = void 0,
      timestamp = void 0;

  function later() {
    var diff = Date.now() - timestamp;

    if (diff < wait && diff >= 0) {
      timeout = setTimeout(later, wait - diff);
    } else {
      timeout = null;
      func.apply(context, args);
      context = args = null;
    }
  }

  return function debounced() {
    context = this;
    for (var _len2 = arguments.length, _args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      _args[_key2] = arguments[_key2];
    }

    args = _args;
    timestamp = Date.now();
    if (!timeout) timeout = setTimeout(later, wait);
  };
}

function isPlainObject(value) {
  if (value == null || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') return false;
  return Object.getPrototypeOf(value) === Object.prototype;
}

function copy(obj, key, value) {
  if (isPlainObject(value)) {
    obj[key] || (obj[key] = {});
    deepExtend(obj[key], value);
  } else {
    obj[key] = value;
  }
}

function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

function assign(target) {
  for (var _len3 = arguments.length, sources = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sources[_key3 - 1] = arguments[_key3];
  }

  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    for (var key in source) {
      if (hasOwn(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
}

function deepExtend(target, source) {
  if (source == null) {} else if (isPlainObject(source)) {
    var keys = Object.keys(source);
    for (var i = 0, len = keys.length; i < len; i++) {
      copy(target, keys[i], source[keys[i]]);
    }
  } else {
    unreachable();
  }

  return target;
}

function last(arr) {
  return arr[arr.length - 1];
}

function find(arr, predicate, ctx) {
  for (var i = 0, len = arr.length; i < len; i++) {
    if (predicate.call(ctx, arr[i], i, arr)) return arr[i];
  }
  return undefined;
}

function removeFromArray(arr, elem) {
  var idx = arr.indexOf(elem);
  if (idx !== -1) arr.splice(idx, 1);
}

function quickDiff(arrA, arrB) {
  if (arrA.length !== arrB.length) return true;

  for (var i = 0; i < arrA.length; i++) {
    if (arrA[i] !== arrB[i]) return true;
  }

  return false;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return NO_PARENT_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UNCHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return INDETERMINATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UNMATCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DESCENDANT_MATCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MATCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return LOAD_ROOT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return LOAD_CHILDREN_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ASYNC_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BRANCH_PRIORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LEAF_PRIORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_CHILDREN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALL_DESCENDANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LEAF_CHILDREN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return LEAF_DESCENDANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ORDER_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return INPUT_DEBOUNCE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MIN_INPUT_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return KEEP_REMAINING_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return KEY_CODES; });
var NO_PARENT_NODE = null;

var UNCHECKED = 0;
var INDETERMINATE = 1;
var CHECKED = 2;

var UNMATCHED = 0;
var DESCENDANT_MATCHED = 1;
var MATCHED = 2;

var LOAD_ROOT_OPTIONS = 'LOAD_ROOT_OPTIONS';
var LOAD_CHILDREN_OPTIONS = 'LOAD_CHILDREN_OPTIONS';
var ASYNC_SEARCH = 'ASYNC_SEARCH';

var ALL = 'ALL';
var BRANCH_PRIORITY = 'BRANCH_PRIORITY';
var LEAF_PRIORITY = 'LEAF_PRIORITY';

var ALL_CHILDREN = 'ALL_CHILDREN';
var ALL_DESCENDANTS = 'ALL_DESCENDANTS';
var LEAF_CHILDREN = 'LEAF_CHILDREN';
var LEAF_DESCENDANTS = 'LEAF_DESCENDANTS';

var ORDER_SELECTED = 'ORDER_SELECTED';
var LEVEL = 'LEVEL';
var INDEX = 'INDEX';

var INPUT_DEBOUNCE_DELAY = process.env.NODE_ENV === 'testing' ? 10 : 200;
var MIN_INPUT_WIDTH = 5;
var KEEP_REMAINING_HEIGHT = 40;

var KEY_CODES = {
  BACKSPACE: 8,
  ESCAPE: 27,
  DELETE: 46
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external "fuzzysearch"
var external__fuzzysearch_ = __webpack_require__(4);
var external__fuzzysearch__default = /*#__PURE__*/__webpack_require__.n(external__fuzzysearch_);

// EXTERNAL MODULE: ./src/utils.js
var utils = __webpack_require__(0);

// EXTERNAL MODULE: ./src/constants.js
var constants = __webpack_require__(1);

// CONCATENATED MODULE: ./src/mixins/treeselectMixin.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







function sortValueByIndex(a, b) {
  var i = 0;
  do {
    if (a.level < i) return -1;
    if (b.level < i) return 1;
    if (a.index[i] !== b.index[i]) return a.index[i] - b.index[i];
    i++;
  } while (true);
}

function sortValueByLevel(a, b) {
  return a.level !== b.level ? a.level - b.level : sortValueByIndex(a, b);
}

function limitTextDefault(count) {
  return 'and ' + count + ' more';
}

/* harmony default export */ var treeselectMixin = ({
  provide: function provide() {
    return {
      instance: this,

      UNCHECKED: constants["w" /* UNCHECKED */],
      INDETERMINATE: constants["h" /* INDETERMINATE */],
      CHECKED: constants["f" /* CHECKED */],
      UNMATCHED: constants["x" /* UNMATCHED */],
      DESCENDANT_MATCHED: constants["g" /* DESCENDANT_MATCHED */],
      MATCHED: constants["s" /* MATCHED */]
    };
  },


  props: {
    alwaysOpen: {
      type: Boolean,
      default: false
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    autoFocus: {
      type: Boolean,
      default: false
    },

    autoLoadRootOptions: {
      type: Boolean,
      default: true
    },

    backspaceRemoves: {
      type: Boolean,
      default: true
    },

    beforeClearAll: {
      type: Function,
      default: Object(utils["b" /* constant */])(true)
    },

    branchNodesFirst: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: true
    },

    clearAllText: {
      type: String,
      default: 'Clear all'
    },

    clearOnSelect: {
      type: Boolean,
      default: false
    },

    clearValueText: {
      type: String,
      default: 'Clear value'
    },

    closeOnSelect: {
      type: Boolean,
      default: true
    },

    defaultExpandLevel: {
      type: Number,
      default: 0
    },

    deleteRemoves: {
      type: Boolean,
      default: true
    },

    delimiter: {
      type: String,
      default: ','
    },

    disableBranchNodes: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    disableFuzzyMatching: {
      type: Boolean,
      default: false
    },

    searchNested: {
      type: Boolean,
      default: false
    },

    escapeClearsValue: {
      type: Boolean,
      default: true
    },

    flat: {
      type: Boolean,
      default: false
    },

    id: {
      default: null
    },

    joinValues: {
      type: Boolean,
      default: false
    },

    limit: {
      type: Number,
      default: Infinity
    },

    limitText: {
      type: Function,
      default: limitTextDefault
    },

    loading: {
      type: Boolean,
      default: false
    },

    loadingText: {
      type: String,
      default: 'Loading...'
    },

    loadOptions: {
      type: Function
    },

    maxHeight: {
      type: Number,
      default: 300
    },

    multiple: {
      type: Boolean,
      default: false
    },

    name: {
      type: String
    },

    noChildrenText: {
      type: String,
      default: 'No sub-options.'
    },

    noOptionsText: {
      type: String,
      default: 'No options available.'
    },

    noResultsText: {
      type: String,
      default: 'No results found...'
    },

    normalizer: {
      type: Function,
      default: utils["g" /* identity */]
    },

    openDirection: {
      type: String,
      default: 'auto'
    },

    openOnClick: {
      type: Boolean,
      default: true
    },

    openOnFocus: {
      type: Boolean,
      default: false
    },

    options: {
      type: Array
    },

    placeholder: {
      type: String,
      default: 'Select...'
    },

    required: {
      type: Boolean,
      default: false
    },

    retainScrollPosition: {
      type: Boolean,
      default: true
    },

    retryText: {
      type: String,
      default: 'Retry?'
    },

    retryTitle: {
      type: String,
      default: 'Click to retry'
    },

    searchable: {
      type: Boolean,
      default: true
    },

    showCount: {
      type: Boolean,
      default: false
    },

    showCountOf: {
      type: String,
      default: constants["b" /* ALL_CHILDREN */],
      validator: function validator(value) {
        var acceptableValues = [constants["b" /* ALL_CHILDREN */], constants["c" /* ALL_DESCENDANTS */], constants["m" /* LEAF_CHILDREN */], constants["n" /* LEAF_DESCENDANTS */]];
        return acceptableValues.indexOf(value) !== -1;
      }
    },

    showCountOnSearch: null,

    sortValueBy: {
      type: String,
      default: constants["v" /* ORDER_SELECTED */],
      validator: function validator(value) {
        var acceptableValues = [constants["v" /* ORDER_SELECTED */], constants["p" /* LEVEL */], constants["i" /* INDEX */]];
        return acceptableValues.indexOf(value) !== -1;
      }
    },

    tabIndex: {
      type: Number,
      default: 0
    },

    value: null,

    valueConsistsOf: {
      type: String,
      default: constants["e" /* BRANCH_PRIORITY */],
      validator: function validator(value) {
        var acceptableValues = [constants["a" /* ALL */], constants["e" /* BRANCH_PRIORITY */], constants["o" /* LEAF_PRIORITY */]];
        return acceptableValues.indexOf(value) !== -1;
      }
    },

    valueFormat: {
      type: String,
      default: 'id'
    }
  },

  data: function data() {
    return {
      normalizedOptions: null,
      selectedNodeIds: this.extractCheckedNodeIdsFromValue(),
      nodeCheckedStateMap: Object(utils["c" /* createEmptyObjectWithoutPrototype */])(),
      nodeMap: Object(utils["c" /* createEmptyObjectWithoutPrototype */])(),
      selectedNodeMap: Object(utils["c" /* createEmptyObjectWithoutPrototype */])(),
      isFocused: false,
      isOpen: false,
      rootOptionsLoaded: false,
      loadingRootOptions: false,
      loadingRootOptionsError: '',
      noSearchResults: true,
      searchingCount: Object(utils["c" /* createEmptyObjectWithoutPrototype */])(),
      searching: false,
      searchQuery: '',
      lastScrollPosition: 0,
      optimizedHeight: 0,
      prefferedOpenDirection: 'below'
    };
  },


  computed: {
    selectedNodes: function selectedNodes() {
      return this.selectedNodeIds.map(this.getNode);
    },
    internalValue: function internalValue() {
      var _this = this;

      var internalValue = void 0;

      if (this.single || this.flat || this.valueConsistsOf === constants["a" /* ALL */]) {
        internalValue = this.selectedNodeIds.slice();
      } else if (this.valueConsistsOf === constants["e" /* BRANCH_PRIORITY */]) {
        internalValue = this.selectedNodeIds.filter(function (id) {
          var node = _this.getNode(id);
          if (node.isRootNode) return true;
          return !_this.isSelected(node.parentNode);
        });
      } else if (this.valueConsistsOf === constants["o" /* LEAF_PRIORITY */]) {
        internalValue = this.selectedNodeIds.filter(function (id) {
          var node = _this.getNode(id);
          if (node.isLeaf) return true;
          return node.children.length === 0;
        });
      }

      if (this.sortValueBy === constants["p" /* LEVEL */]) {
        internalValue.sort(function (a, b) {
          return sortValueByLevel(_this.getNode(a), _this.getNode(b));
        });
      } else if (this.sortValueBy === constants["i" /* INDEX */]) {
        internalValue.sort(function (a, b) {
          return sortValueByIndex(_this.getNode(a), _this.getNode(b));
        });
      }

      return internalValue;
    },
    hasValue: function hasValue() {
      return this.internalValue.length > 0;
    },
    hasUndisabledValue: function hasUndisabledValue() {
      return this.hasValue && this.internalValue.map(this.getNode).some(function (node) {
        return !node.isDisabled;
      });
    },
    single: function single() {
      return !this.multiple;
    },
    visibleValue: function visibleValue() {
      return this.internalValue.map(this.getNode).slice(0, this.limit);
    },
    hasExceededLimit: function hasExceededLimit() {
      return this.internalValue.length > this.limit;
    },
    shouldShowX: function shouldShowX() {
      return this.clearable && !this.disabled && this.hasUndisabledValue;
    },
    showCountOnSearchComputed: function showCountOnSearchComputed() {
      return typeof this.showCountOnSearch === 'boolean' ? this.showCountOnSearch : this.showCount;
    },
    hasBranchNodes: function hasBranchNodes() {
      return this.normalizedOptions.some(function (rootNode) {
        return rootNode.isBranch;
      });
    }
  },

  watch: {
    alwaysOpen: function alwaysOpen(newValue) {
      if (newValue) this.openMenu();else this.closeMenu();
    },
    disabled: function disabled(newValue) {
      if (newValue && this.isOpen) this.closeMenu();
      if (!newValue && !this.isOpen && this.alwaysOpen) this.openMenu();
    },
    internalValue: function internalValue() {
      this.$emit('input', this.getValue(), this.id);
    },
    multiple: function multiple(newValue) {
      if (newValue) {
        this.buildNodeCheckedStateMap();
      }
    },


    searchQuery: Object(utils["d" /* debounce */])(function onSearchQueryChange() {
      this.handleSearch();
      this.$emit('search-change', this.searchQuery, this.id);
    }, constants["j" /* INPUT_DEBOUNCE_DELAY */]),

    value: function value() {
      var newInternalValue = this.extractCheckedNodeIdsFromValue();
      var hasChanged = Object(utils["l" /* quickDiff */])(newInternalValue, this.internalValue);

      if (hasChanged) {
        this.selectedNodeIds = newInternalValue;
        this.completeSelectedNodeIdList();
        this.buildSelectedNodeMap();
        this.buildNodeCheckedStateMap();
      }
    }
  },

  methods: {
    verifyProps: function verifyProps() {
      var _this2 = this;

      Object(utils["n" /* warning */])(function () {
        return _this2.autofocus === false;
      }, function () {
        return '`autofocus` prop is deprecated. Use `autoFocus` instead.';
      });

      if (this.options == null && !this.loadOptions) {
        Object(utils["n" /* warning */])(function () {
          return false;
        }, function () {
          return 'Are you meant to dynamically loading options? You need to use `loadOptions` prop.';
        });
      }
    },
    resetFlags: function resetFlags() {
      this._blurOnSelect = false;
      this._wasClickedOnValueItem = false;
    },
    initialize: function initialize(rootOptions) {
      if (Array.isArray(rootOptions)) {
        var prevNodeMap = this.nodeMap;
        this.nodeMap = Object(utils["c" /* createEmptyObjectWithoutPrototype */])();
        this.keepDataOfSelectedNodes(prevNodeMap);
        this.normalizedOptions = this.normalize(constants["u" /* NO_PARENT_NODE */], rootOptions, prevNodeMap);
        this.completeSelectedNodeIdList();
        this.buildSelectedNodeMap();
        this.buildNodeCheckedStateMap();
        this.rootOptionsLoaded = true;
      } else {
        this.normalizedOptions = [];
      }
    },
    getValue: function getValue() {
      var _this3 = this;

      if (this.valueFormat === 'id') {
        return this.multiple ? this.internalValue.slice() : this.internalValue[0];
      }

      var rawNodes = this.internalValue.map(function (id) {
        return _this3.getNode(id).raw;
      });
      return this.multiple ? rawNodes : rawNodes[0];
    },
    getNode: function getNode(nodeId) {
      Object(utils["n" /* warning */])(function () {
        return nodeId != null;
      }, function () {
        return 'Invalid node id: ' + nodeId;
      });

      if (nodeId == null) return null;

      return nodeId in this.nodeMap ? this.nodeMap[nodeId] : this.createFallbackNode(nodeId);
    },
    createFallbackNode: function createFallbackNode(id) {

      var raw = this.extractNodeFromValue(id);
      var label = this.enhancedNormalizer(raw).label || id + ' (unknown)';
      var fallbackNode = {
        id: id,
        label: label,
        ancestors: [],
        parentNode: constants["u" /* NO_PARENT_NODE */],
        isFallbackNode: true,
        isRootNode: true,
        isLeaf: true,
        isBranch: false,
        isDisabled: false,
        index: [-1],
        level: 0,
        raw: raw
      };

      this.$set(this.nodeMap, id, fallbackNode);
      return fallbackNode;
    },
    extractCheckedNodeIdsFromValue: function extractCheckedNodeIdsFromValue() {
      var _this4 = this;

      if (this.value == null) return [];

      if (this.valueFormat === 'id') {
        return this.multiple ? this.value.slice() : [this.value];
      }

      return (this.multiple ? this.value : [this.value]).map(function (node) {
        return _this4.enhancedNormalizer(node);
      }).map(function (node) {
        return node.id;
      });
    },
    extractNodeFromValue: function extractNodeFromValue(id) {
      var _this5 = this;

      var defaultNode = { id: id };

      if (this.valueFormat === 'id') {
        return defaultNode;
      }

      var valueArray = this.multiple ? Array.isArray(this.value) ? this.value : [] : this.value ? [this.value] : [];
      var matched = Object(utils["f" /* find */])(valueArray, function (node) {
        return node && _this5.enhancedNormalizer(node).id === id;
      });

      return matched || defaultNode;
    },
    completeSelectedNodeIdList: function completeSelectedNodeIdList() {
      var _this6 = this;

      var nodeIds = this.selectedNodeIds.slice();
      this.selectedNodeIds = [];
      this.nodeCheckedStateMap = Object(utils["c" /* createEmptyObjectWithoutPrototype */])();
      this.selectedNodeMap = Object(utils["c" /* createEmptyObjectWithoutPrototype */])();
      nodeIds.forEach(function (id) {
        if (_this6.selectedNodeIds.indexOf(id) === -1) {
          _this6._selectNode(_this6.getNode(id), { ignoreDisabled: true });
        }
      });
    },
    keepDataOfSelectedNodes: function keepDataOfSelectedNodes(prevNodeMap) {
      var _this7 = this;

      this.selectedNodeIds.forEach(function (id) {
        if (!prevNodeMap[id]) return;
        var fallbackNode = Object(utils["a" /* assign */])({}, prevNodeMap[id], {
          isFallbackNode: true
        });
        _this7.$set(_this7.nodeMap, id, fallbackNode);
      });
    },
    isSelected: function isSelected(node) {
      return this.selectedNodeMap[node.id] === true;
    },
    checkIfBranchNode: function checkIfBranchNode(node) {
      Object(utils["n" /* warning */])(function () {
        return node && node.isBranch;
      }, function () {
        return 'Expected a branch node, instead got: ' + node;
      });
    },
    stringifyValue: function stringifyValue(value) {
      return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
    },
    traverseDescendantsBFS: function traverseDescendantsBFS(parentNode, callback) {
      if (!parentNode.isBranch) return;
      var queue = parentNode.children.slice();
      while (queue.length) {
        var currNode = queue[0];
        if (currNode.isBranch) queue.push.apply(queue, _toConsumableArray(currNode.children));
        callback(currNode);
        queue.shift();
      }
    },
    traverseDescendantsDFS: function traverseDescendantsDFS(parentNode, callback) {
      var _this8 = this;

      if (!parentNode.isBranch) return;
      parentNode.children.forEach(function (child) {
        _this8.traverseDescendantsDFS(child, callback);
        callback(child);
      });
    },
    traverseAncestors: function traverseAncestors(childNode, callback) {
      var parentNode = childNode.parentNode;


      if (parentNode !== constants["u" /* NO_PARENT_NODE */]) {
        callback(parentNode);
        this.traverseAncestors(parentNode, callback);
      }
    },
    traverseAllNodes: function traverseAllNodes(callback) {
      var _this9 = this;

      this.normalizedOptions.forEach(function (rootNode) {
        _this9.traverseDescendantsDFS(rootNode, callback);
        callback(rootNode);
      });
    },
    toggleClickOutsideEvent: function toggleClickOutsideEvent(enabled) {
      if (enabled) {
        document.addEventListener('mousedown', this.handleClickOutside, false);
      } else {
        document.removeEventListener('mousedown', this.handleClickOutside, false);
      }
    },
    focusInput: function focusInput() {
      this.$refs.value.focusInput();
    },
    blurInput: function blurInput() {
      this.$refs.value.blurInput();
    },


    handleMouseDown: Object(utils["k" /* onlyOnLeftClick */])(function handleMouseDown(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if (this.disabled) return;

      var isClickedOnValueWrapper = this.$refs.value.$el.contains(evt.target);

      if (isClickedOnValueWrapper) {
        if (this.isOpen && !this.searchable && !this._wasClickedOnValueItem) {
          this.closeMenu();
        } else if (!this.isOpen && (this.openOnClick || this.isFocused)) {
          this.openMenu();
        }
      }

      if (this._blurOnSelect) {
        this.blurInput();
      } else {
        this.focusInput();
      }

      this.resetFlags();
    }),

    handleMouseDownOnClear: Object(utils["k" /* onlyOnLeftClick */])(function handleMouseDownOnClear(evt) {
      var _this10 = this;

      evt.stopPropagation();
      evt.preventDefault();

      var result = this.beforeClearAll();
      var handler = function handler(shouldClear) {
        if (shouldClear) {
          _this10.clear();
        }

        _this10.focusInput();
      };

      if (Object(utils["h" /* isPromise */])(result)) {
        result.then(handler);
      } else {
        setTimeout(function () {
          return handler(result);
        }, 0);
      }
    }),

    handleMouseDownOnArrow: Object(utils["k" /* onlyOnLeftClick */])(function handleMouseDownOnArrow(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      this.focusInput();
      this.toggleMenu();
    }),

    handleClickOutside: function handleClickOutside(evt) {
      if (this.$refs.wrapper && !this.$refs.wrapper.contains(evt.target)) {
        this.blurInput();
        this.closeMenu();
      }
    },
    handleSearch: function handleSearch() {
      var _this11 = this;

      if (this.searchQuery) {
        this.searching = true;
        this.noSearchResults = true;

        this.traverseAllNodes(function (node) {
          if (node.isBranch) {
            var _this11$$set;

            node.expandsOnSearch = false;
            node.hasMatchedChild = false;
            _this11.$set(_this11.searchingCount, node.id, (_this11$$set = {}, _defineProperty(_this11$$set, constants["b" /* ALL_CHILDREN */], 0), _defineProperty(_this11$$set, constants["c" /* ALL_DESCENDANTS */], 0), _defineProperty(_this11$$set, constants["m" /* LEAF_CHILDREN */], 0), _defineProperty(_this11$$set, constants["n" /* LEAF_DESCENDANTS */], 0), _this11$$set));
          }
        });
        var lowerCasedSearchQuery = this.searchQuery.trim().toLocaleLowerCase();
        var splitSearchQuery = lowerCasedSearchQuery.replace(/\s+/g, ' ').split(' ');
        this.traverseAllNodes(function (node) {
          var isMatched = void 0;
          if (_this11.searchNested && splitSearchQuery.length > 1) {
            isMatched = node.isMatched = splitSearchQuery.every(function (filterValue) {
              return node.nestedSearchLabel.indexOf(filterValue) !== -1;
            });
          } else {
            isMatched = node.isMatched = _this11.disableFuzzyMatching ? node.lowerCasedLabel.indexOf(lowerCasedSearchQuery) !== -1 : external__fuzzysearch__default()(lowerCasedSearchQuery, node.lowerCasedLabel);
          }
          if (isMatched) {
            _this11.noSearchResults = false;
            node.ancestors.forEach(function (ancestor) {
              return _this11.searchingCount[ancestor.id].ALL_DESCENDANTS++;
            });
            if (node.isLeaf) node.ancestors.forEach(function (ancestor) {
              return _this11.searchingCount[ancestor.id].LEAF_DESCENDANTS++;
            });
            if (node.parentNode !== constants["u" /* NO_PARENT_NODE */]) {
              _this11.searchingCount[node.parentNode.id].ALL_CHILDREN += 1;

              if (node.isLeaf) _this11.searchingCount[node.parentNode.id].LEAF_CHILDREN += 1;
            }
          }

          if ((isMatched || node.isBranch && node.expandsOnSearch) && node.parentNode !== constants["u" /* NO_PARENT_NODE */]) {
            node.parentNode.expandsOnSearch = true;
            node.parentNode.hasMatchedChild = true;
          }
        });
      } else {
        this.searching = false;
      }
    },
    closeMenu: function closeMenu() {
      if (!this.isOpen || !this.disabled && this.alwaysOpen) return;

      if (this.retainScrollPosition) this.saveScrollPosition();
      this.isOpen = false;
      this.toggleClickOutsideEvent(false);

      this.searchQuery = '';
      this.$emit('close', this.getValue(), this.id);
    },
    openMenu: function openMenu() {
      if (this.disabled || this.isOpen) return;
      this.isOpen = true;
      this.$nextTick(this.adjustPosition);

      if (this.retainScrollPosition) this.$nextTick(this.restoreScrollPosition);
      if (!this.rootOptionsLoaded) this.loadRootOptions();
      this.toggleClickOutsideEvent(true);
      this.$emit('open', this.id);
    },
    toggleMenu: function toggleMenu() {
      if (this.isOpen) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    },
    toggleExpanded: function toggleExpanded(node) {
      this.checkIfBranchNode(node);

      if (this.searching) {
        node.expandsOnSearch = !node.expandsOnSearch;
      } else {
        node.isExpanded = !node.isExpanded;
      }
    },
    buildSelectedNodeMap: function buildSelectedNodeMap() {
      var map = Object(utils["c" /* createEmptyObjectWithoutPrototype */])();

      this.selectedNodeIds.forEach(function (selectedNodeId) {
        map[selectedNodeId] = true;
      });

      this.selectedNodeMap = map;
    },
    buildNodeCheckedStateMap: function buildNodeCheckedStateMap() {
      var _this12 = this;

      var map = Object(utils["c" /* createEmptyObjectWithoutPrototype */])();

      if (this.multiple) {
        this.selectedNodes.forEach(function (selectedNode) {
          map[selectedNode.id] = constants["f" /* CHECKED */];

          if (!_this12.flat) {
            _this12.traverseAncestors(selectedNode, function (ancestorNode) {
              if (!_this12.isSelected(ancestorNode)) {
                map[ancestorNode.id] = constants["h" /* INDETERMINATE */];
              }
            });
          }
        });

        this.traverseAllNodes(function (node) {
          if (!(node.id in map)) {
            map[node.id] = constants["w" /* UNCHECKED */];
          }
        });
      }

      this.nodeCheckedStateMap = map;
    },
    enhancedNormalizer: function enhancedNormalizer(raw) {
      return Object(utils["a" /* assign */])({}, raw, this.normalizer(raw, this.id));
    },
    normalize: function normalize(parentNode, nodes, prevNodeMap) {
      var _this13 = this;

      var normalizedOptions = nodes.map(function (node) {
        return [_this13.enhancedNormalizer(node), node];
      }).map(function (_ref, index) {
        var _ref2 = _slicedToArray(_ref, 2),
            node = _ref2[0],
            raw = _ref2[1];

        _this13.checkDuplication(node);
        _this13.verifyNodeShape(node);

        var id = node.id,
            label = node.label,
            children = node.children,
            isDefaultExpanded = node.isDefaultExpanded;

        var isRootNode = parentNode === constants["u" /* NO_PARENT_NODE */];
        var level = isRootNode ? 0 : parentNode.level + 1;
        var isBranch = Array.isArray(children) || children === null;
        var isLeaf = !isBranch;
        var isDisabled = !!node.isDisabled || !_this13.flat && !isRootNode && parentNode.isDisabled;
        var lowerCasedLabel = label.toLocaleLowerCase();
        var nestedSearchLabel = isRootNode ? lowerCasedLabel : parentNode.nestedSearchLabel + ' ' + lowerCasedLabel;

        var normalized = _this13.$set(_this13.nodeMap, id, Object(utils["c" /* createEmptyObjectWithoutPrototype */])());
        _this13.$set(normalized, 'id', id);
        _this13.$set(normalized, 'label', label);
        _this13.$set(normalized, 'level', level);
        _this13.$set(normalized, 'ancestors', isRootNode ? [] : parentNode.ancestors.concat(parentNode));
        _this13.$set(normalized, 'index', (isRootNode ? [] : parentNode.index).concat(index));
        _this13.$set(normalized, 'parentNode', parentNode);
        _this13.$set(normalized, 'lowerCasedLabel', lowerCasedLabel);
        _this13.$set(normalized, 'nestedSearchLabel', nestedSearchLabel);
        _this13.$set(normalized, 'isDisabled', isDisabled);
        _this13.$set(normalized, 'isMatched', false);
        _this13.$set(normalized, 'isBranch', isBranch);
        _this13.$set(normalized, 'isLeaf', isLeaf);
        _this13.$set(normalized, 'isRootNode', isRootNode);
        _this13.$set(normalized, 'raw', raw);

        if (isBranch) {
          var _this13$$set;

          var isLoaded = Array.isArray(children);

          _this13.$set(normalized, 'isLoaded', isLoaded);
          _this13.$set(normalized, 'isPending', false);
          _this13.$set(normalized, 'isExpanded', typeof isDefaultExpanded === 'boolean' ? isDefaultExpanded : level < _this13.defaultExpandLevel);
          _this13.$set(normalized, 'hasMatchedChild', false);
          _this13.$set(normalized, 'hasDisabledDescendants', false);
          _this13.$set(normalized, 'expandsOnSearch', false);
          _this13.$set(normalized, 'loadingChildrenError', '');
          _this13.$set(normalized, 'count', (_this13$$set = {}, _defineProperty(_this13$$set, constants["b" /* ALL_CHILDREN */], 0), _defineProperty(_this13$$set, constants["c" /* ALL_DESCENDANTS */], 0), _defineProperty(_this13$$set, constants["m" /* LEAF_CHILDREN */], 0), _defineProperty(_this13$$set, constants["n" /* LEAF_DESCENDANTS */], 0), _this13$$set));
          _this13.$set(normalized, 'children', isLoaded ? _this13.normalize(normalized, children, prevNodeMap) : []);

          if (!isLoaded && typeof _this13.loadOptions !== 'function') {
            Object(utils["n" /* warning */])(function () {
              return false;
            }, function () {
              return 'Unloaded branch node detected. `loadOptions` prop is required to load its children.';
            });
          } else if (!isLoaded && normalized.isExpanded) {
            _this13.loadChildrenOptions(normalized);
          }
        }

        normalized.ancestors.forEach(function (ancestor) {
          return ancestor.count.ALL_DESCENDANTS++;
        });
        if (isLeaf) normalized.ancestors.forEach(function (ancestor) {
          return ancestor.count.LEAF_DESCENDANTS++;
        });
        if (parentNode !== constants["u" /* NO_PARENT_NODE */]) {
          parentNode.count.ALL_CHILDREN += 1;
          if (isLeaf) parentNode.count.LEAF_CHILDREN += 1;
        }

        if (isDisabled) {
          normalized.ancestors.forEach(function (ancestor) {
            return ancestor.hasDisabledDescendants = true;
          });
        }

        if (prevNodeMap && prevNodeMap[id]) {
          var prev = prevNodeMap[id];
          if (prev.isBranch && normalized.isBranch) {
            normalized.isExpanded = prev.isExpanded;
            normalized.expandsOnSearch = prev.expandsOnSearch;
            normalized.isPending = prev.isPending;
            normalized.loadingChildrenError = prev.loadingChildrenError;
          }
        }

        return normalized;
      });

      if (this.branchNodesFirst) {
        var branchNodes = normalizedOptions.filter(function (option) {
          return option.isBranch;
        });
        var leafNodes = normalizedOptions.filter(function (option) {
          return option.isLeaf;
        });
        normalizedOptions = branchNodes.concat(leafNodes);
      }

      return normalizedOptions;
    },
    loadRootOptions: function loadRootOptions() {
      var _this14 = this;

      this.callLoadOptionsProp({
        action: constants["r" /* LOAD_ROOT_OPTIONS */],
        isPending: function isPending() {
          return _this14.loadingRootOptions;
        },
        start: function start() {
          _this14.loadingRootOptions = true;
          _this14.loadingRootOptionsError = '';
        },
        succeed: function succeed() {
          _this14.rootOptionsLoaded = true;
        },
        fail: function fail(err) {
          _this14.loadingRootOptionsError = err.message || String(err);
        },
        end: function end() {
          _this14.loadingRootOptions = false;
        }
      });
    },
    loadChildrenOptions: function loadChildrenOptions(parentNode) {
      var _this15 = this;

      var id = parentNode.id,
          raw = parentNode.raw;


      this.callLoadOptionsProp({
        action: constants["q" /* LOAD_CHILDREN_OPTIONS */],
        args: {
          parentNode: raw
        },
        isPending: function isPending() {
          return _this15.getNode(id).isPending;
        },
        start: function start() {
          _this15.getNode(id).isPending = true;
          _this15.getNode(id).loadingChildrenError = '';
        },
        succeed: function succeed() {
          _this15.getNode(id).isLoaded = true;
        },
        fail: function fail(err) {
          _this15.getNode(id).loadingChildrenError = err.message || String(err);
        },
        end: function end() {
          _this15.getNode(id).isPending = false;
        }
      });
    },
    callLoadOptionsProp: function callLoadOptionsProp(_ref3) {
      var action = _ref3.action,
          args = _ref3.args,
          isPending = _ref3.isPending,
          start = _ref3.start,
          succeed = _ref3.succeed,
          fail = _ref3.fail,
          end = _ref3.end;

      if (!this.loadOptions || isPending()) {
        return;
      }

      var callback = Object(utils["j" /* once */])(function (err) {
        if (err) {
          fail(err);
        } else {
          succeed();
        }

        end();
      });

      start();
      var result = this.loadOptions(_extends({ id: this.id, action: action }, args, { callback: callback }));

      if (Object(utils["h" /* isPromise */])(result)) {
        result.then(function () {
          callback();
        }, function (err) {
          callback(err);
        });
      }
    },
    checkDuplication: function checkDuplication(node) {
      var _this16 = this;

      Object(utils["n" /* warning */])(function () {
        return !(node.id in _this16.nodeMap && !_this16.nodeMap[node.id].isFallbackNode);
      }, function () {
        return 'Detected duplicate presence of node id ' + JSON.stringify(node.id) + '. ' + ('Their labels are "' + _this16.nodeMap[node.id].label + '" and "' + node.label + '" respectively.');
      });
    },
    verifyNodeShape: function verifyNodeShape(node) {
      Object(utils["n" /* warning */])(function () {
        return !(node.children === undefined && node.isBranch === true);
      }, function () {
        return 'Are you meant to declares an unloaded branch node? ' + '`isBranch: true` is no longer supported, please use `children: null` instead.';
      });
    },
    select: function select(node) {
      if (node.isDisabled) {
        return;
      }

      if (this.single) {
        this.clear();
      }

      var state = this.multiple && !this.flat ? this.nodeCheckedStateMap[node.id] === constants["w" /* UNCHECKED */] : !this.isSelected(node);

      if (state) {
        this._selectNode(node);
      } else {
        this._deselectNode(node);
      }

      this.buildSelectedNodeMap();
      this.buildNodeCheckedStateMap();

      if (state) {
        this.$emit('select', node.raw, this.id);
      } else {
        this.$emit('deselect', node.raw, this.id);
      }

      if (this.searching && state && (this.single || this.clearOnSelect)) {
        this.searchQuery = '';
      }

      if (this.single && this.closeOnSelect) {
        this.closeMenu();

        if (this.searchable) {
          this._blurOnSelect = true;
        }
      }
    },
    clear: function clear() {
      var _this17 = this;

      if (this.hasValue) {
        this.selectedNodeIds = this.multiple ? this.selectedNodeIds.filter(function (nodeId) {
          return _this17.getNode(nodeId).isDisabled;
        }) : [];
        this.buildSelectedNodeMap();
        this.buildNodeCheckedStateMap();
      }
    },
    _selectNode: function _selectNode(node) {
      var _this18 = this;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$ignoreDisabled = _ref4.ignoreDisabled,
          ignoreDisabled = _ref4$ignoreDisabled === undefined ? false : _ref4$ignoreDisabled;

      if (this.single || this.flat || this.disableBranchNodes) {
        this.addValue(node);
        return;
      }

      if (node.isLeaf || node.isBranch && (!node.hasDisabledDescendants || ignoreDisabled)) {
        this.addValue(node);
      }

      if (node.isBranch) {
        this.traverseDescendantsBFS(node, function (descendant) {
          if (!descendant.isDisabled || ignoreDisabled) _this18.addValue(descendant);
        });
      }

      if (node.isLeaf || node.isBranch && (!node.hasDisabledDescendants || ignoreDisabled)) {
        var curr = node;
        while (!curr.isRootNode) {
          curr = curr.parentNode;
          var siblings = curr.children;
          if (siblings.every(this.isSelected)) {
            this.addValue(curr);
          } else {
            break;
          }
        }
      }
    },
    _deselectNode: function _deselectNode(node) {
      var _this19 = this;

      if (this.single || this.flat || this.disableBranchNodes) {
        this.removeValue(node);
        return;
      }

      var hasUncheckedSomeDescendants = false;
      if (node.isBranch) {
        this.traverseDescendantsDFS(node, function (descendant) {
          if (!descendant.isDisabled) {
            _this19.removeValue(descendant);
            hasUncheckedSomeDescendants = true;
          }
        });
      }

      switch (true) {
        case node.isLeaf:
        case hasUncheckedSomeDescendants:
        case node.children.length === 0:
          {
            this.removeValue(node);

            var curr = node;
            while (!curr.isRootNode) {
              curr = curr.parentNode;
              if (this.isSelected(curr)) {
                this.removeValue(curr);
              } else {
                break;
              }
            }
            break;
          }

        default:
      }
    },
    addValue: function addValue(node) {
      this.selectedNodeIds.push(node.id);
      this.selectedNodeMap[node.id] = true;
    },
    removeValue: function removeValue(node) {
      Object(utils["m" /* removeFromArray */])(this.selectedNodeIds, node.id);
      delete this.selectedNodeMap[node.id];
    },
    maybeRemoveLastValue: function maybeRemoveLastValue() {
      if (!this.hasValue) return;
      var lastValue = Object(utils["i" /* last */])(this.selectedNodeIds);
      var lastSelectedNode = this.getNode(lastValue);
      this.removeValue(lastSelectedNode);
      this.buildSelectedNodeMap();
      this.buildNodeCheckedStateMap();
    },
    saveScrollPosition: function saveScrollPosition() {
      if (this.$refs.menu) this.lastScrollPosition = this.$refs.menu.scrollTop;
    },
    restoreScrollPosition: function restoreScrollPosition() {
      if (this.$refs.menu) this.$refs.menu.scrollTop = this.lastScrollPosition;
    },
    adjustPosition: function adjustPosition() {
      if (typeof window === 'undefined') return;

      var rect = this.$el.getBoundingClientRect();
      var spaceAbove = rect.top;
      var spaceBelow = window.innerHeight - rect.bottom;
      var hasEnoughSpaceBelow = spaceBelow > this.maxHeight;
      var isInViewport = rect.top > 0 && window.innerHeight - rect.top > constants["k" /* KEEP_REMAINING_HEIGHT */];

      switch (true) {
        case hasEnoughSpaceBelow:
        case spaceBelow > spaceAbove:
        case !isInViewport:
        case this.openDirection === 'below':
        case this.openDirection === 'bottom':
          this.prefferedOpenDirection = 'below';
          this.optimizedHeight = Math.max(Math.min(spaceBelow - constants["k" /* KEEP_REMAINING_HEIGHT */], this.maxHeight), this.maxHeight);
          break;

        default:
          this.prefferedOpenDirection = 'above';
          this.optimizedHeight = Math.min(spaceAbove - constants["k" /* KEEP_REMAINING_HEIGHT */], this.maxHeight);
      }
    }
  },

  created: function created() {
    var _this20 = this;

    this.verifyProps();
    this.resetFlags();
    this.initialize(this.options);
    this.$watch('options', function () {
      return _this20.initialize(_this20.options);
    }, { deep: true });
  },
  mounted: function mounted() {
    if (this.autoFocus || this.autofocus) this.$refs.value.focusInput();
    if (!this.rootOptionsLoaded && this.autoLoadRootOptions) this.loadRootOptions();
    if (this.alwaysOpen) this.openMenu();
  },
  destroyed: function destroyed() {
    this.toggleClickOutsideEvent(false);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HiddenField.vue


/* harmony default export */ var HiddenField = ({
  name: 'vue-treeselect--hidden-field',
  inject: ['instance'],

  props: {
    stringifiedValue: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a30e55","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HiddenField.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"hidden","name":_vm.instance.name,"disabled":_vm.instance.disabled},domProps:{"value":_vm.stringifiedValue}})}
var staticRenderFns = []

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  scriptExports = scriptExports || {}

  // ES6 modules interop
  var type = typeof scriptExports.default
  if (type === 'object' || type === 'function') {
    scriptExports = scriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/HiddenField.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = normalizeComponent(
  HiddenField,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_HiddenField = (Component.exports);

// CONCATENATED MODULE: ./src/mixins/valueMixin.js


/* harmony default export */ var valueMixin = ({
  computed: {
    limitText: function limitText() {
      var count = this.instance.internalValue.length - this.instance.limit;
      return this.instance.limitText(count);
    }
  },

  methods: {
    focusInput: function focusInput() {
      this.$refs.input.focus();
    },
    blurInput: function blurInput() {
      this.$refs.input.blur();
    },


    handleMouseDownOnValue: Object(utils["k" /* onlyOnLeftClick */])(function handleMouseDownOnValue() {
      this.instance._wasClickedOnValueItem = true;
    }),

    handleMouseDownOnValueRemove: Object(utils["k" /* onlyOnLeftClick */])(function handleMouseDownOnValueRemove(evt, node) {
      this.instance.select(node);
    })
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Placeholder.vue


/* harmony default export */ var Placeholder = ({
  name: 'vue-treeselect--placeholder',
  inject: ['instance']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed1e0d7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Placeholder.vue
var Placeholder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-treeselect__placeholder vue-treeselect-helper-zoom-effect-off"},[_vm._t("placeholder",[_vm._v(_vm._s(_vm.instance.placeholder))])],2)}
var Placeholder_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/Placeholder.vue
/* script */


/* template */

/* template functional */
var Placeholder___vue_template_functional__ = false
/* styles */
var Placeholder___vue_styles__ = null
/* scopeId */
var Placeholder___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Placeholder___vue_module_identifier__ = null

var Placeholder_Component = normalizeComponent(
  Placeholder,
  Placeholder_render,
  Placeholder_staticRenderFns,
  Placeholder___vue_template_functional__,
  Placeholder___vue_styles__,
  Placeholder___vue_scopeId__,
  Placeholder___vue_module_identifier__
)

/* harmony default export */ var components_Placeholder = (Placeholder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchInput.vue




/* harmony default export */ var SearchInput = ({
  name: 'vue-treeselect--input',
  inject: ['instance'],

  data: function data() {
    return {
      inputWidth: constants["t" /* MIN_INPUT_WIDTH */]
    };
  },

  computed: {
    needsAutoSize: function needsAutoSize() {
      return this.instance.multiple;
    }
  },

  updated: function updated() {
    if (this.needsAutoSize) this.updateInputWidth();
  },


  methods: {
    focus: function focus() {
      if (!this.instance.disabled) {
        this.$refs.input && this.$refs.input.focus();
      }
    },
    blur: function blur() {
      this.$refs.input && this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.instance.isFocused = true;

      if (this.instance.openOnFocus) this.instance.openMenu();
    },
    onBlur: function onBlur() {
      if (document.activeElement === this.instance.$refs.menu) {
        this.focus();
        return;
      }

      this.instance.isFocused = false;
      this.instance.closeMenu();
    },
    onInput: function onInput(evt) {
      this.instance.searchQuery = evt.target.value;
    },
    onKeyDown: function onKeyDown(evt) {
      if (evt.ctrlKey || evt.shiftKey || evt.altKey || evt.metaKey) return;

      switch ('which' in evt ? evt.which : evt.keyCode) {
        case constants["l" /* KEY_CODES */].BACKSPACE:
          {
            if (this.instance.backspaceRemoves && !this.instance.searchQuery.length) {
              this.instance.maybeRemoveLastValue();
            }
            break;
          }
        case constants["l" /* KEY_CODES */].DELETE:
          {
            if (this.instance.deleteRemoves && !this.instance.searchQuery.length) {
              this.instance.maybeRemoveLastValue();
            }
            break;
          }
        case constants["l" /* KEY_CODES */].ESCAPE:
          {
            if (this.instance.searchQuery.length) {
              this.instance.searchQuery = '';
            } else if (this.instance.isOpen) {
              this.instance.closeMenu();
            } else if (this.instance.escapeClearsValue) {
              this.instance.clear();
            }
            break;
          }
        default:
          {
            this.instance.openMenu();
          }
      }
    },
    onMouseDown: function onMouseDown(evt) {
      if (this.instance.searchQuery.length) {
        evt.stopPropagation();
      }
    },
    renderInputWrapper: function renderInputWrapper(h) {
      var props = {
        class: 'vue-treeselect__input-wrapper'
      };
      var children = [];

      if (this.instance.searchable && !this.instance.disabled) {
        children.push(this.renderInput(h));
        if (this.needsAutoSize) children.push(this.renderSizer(h));
      }

      if (!this.instance.searchable) {
        Object(utils["e" /* deepExtend */])(props, {
          on: {
            focus: this.onFocus,
            blur: this.onBlur,
            keydown: this.onKeyDown
          },
          ref: 'input'
        });
      }

      if (!this.instance.searchable && !this.instance.disabled) {
        Object(utils["e" /* deepExtend */])(props, {
          attrs: {
            tabIndex: this.instance.tabIndex
          }
        });
      }

      return h('div', props, children);
    },
    renderInput: function renderInput(h) {
      return h('input', {
        class: 'vue-treeselect__input',
        attrs: {
          type: 'text',
          autocomplete: 'off',
          tabIndex: this.instance.tabIndex,
          required: this.instance.required && !this.instance.hasValue
        },
        domProps: {
          value: this.instance.searchQuery
        },
        style: {
          width: this.needsAutoSize ? this.inputWidth + 'px' : null
        },
        on: {
          focus: this.onFocus,
          input: this.onInput,
          blur: this.onBlur,
          keydown: this.onKeyDown,
          mousedown: this.onMouseDown
        },
        ref: 'input'
      });
    },
    renderSizer: function renderSizer(h) {
      return h('div', {
        class: 'vue-treeselect__sizer',
        domProps: {
          textContent: this.instance.searchQuery
        },
        ref: 'sizer'
      });
    },
    updateInputWidth: function updateInputWidth() {
      this.inputWidth = Math.max(constants["t" /* MIN_INPUT_WIDTH */], this.$refs.sizer.scrollWidth + 8);
    }
  },

  render: function render(h) {
    return this.renderInputWrapper(h);
  }
});
// CONCATENATED MODULE: ./src/components/SearchInput.vue
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var SearchInput___vue_template_functional__ = false
/* styles */
var SearchInput___vue_styles__ = null
/* scopeId */
var SearchInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchInput___vue_module_identifier__ = null

var SearchInput_Component = normalizeComponent(
  SearchInput,
  __vue_render__,
  __vue_static_render_fns__,
  SearchInput___vue_template_functional__,
  SearchInput___vue_styles__,
  SearchInput___vue_scopeId__,
  SearchInput___vue_module_identifier__
)

/* harmony default export */ var components_SearchInput = (SearchInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MultiValue.vue






/* harmony default export */ var MultiValue = ({
  name: 'vue-treeselect--multi-value',
  components: { Placeholder: components_Placeholder, SearchInput: components_SearchInput },
  mixins: [valueMixin],
  inject: ['instance']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42aca818","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultiValue.vue
var MultiValue_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-treeselect__value-wrapper"},[_c('transition-group',{staticClass:"vue-treeselect__multi-value",attrs:{"tag":"div","name":"vue-treeselect__multi-value-item--zoom","appear":""}},[_vm._l((_vm.instance.visibleValue),function(node){return [_c('div',{key:'value-' + node.id,staticClass:"vue-treeselect__multi-value-item-wrapper",on:{"mousedown":_vm.handleMouseDownOnValue}},[_c('div',{class:[ 'vue-treeselect__multi-value-item', { 'vue-treeselect__multi-value-item-disabled': node.isDisabled } ]},[_c('span',{staticClass:"vue-treeselect__multi-value-label"},[_vm._v(_vm._s(node.label))]),_c('span',{staticClass:"vue-treeselect__icon vue-treeselect__value-remove",on:{"mousedown":function($event){_vm.handleMouseDownOnValueRemove($event, node)}}},[_vm._v("×")])])])]}),_vm._v(" "),(_vm.instance.hasExceededLimit)?_c('div',{key:"limit-tip",staticClass:"vue-treeselect__limit-tip vue-treeselect-helper-zoom-effect-off"},[_c('span',{staticClass:"vue-treeselect__limit-tip-text"},[_vm._v(_vm._s(_vm.limitText))])]):_vm._e(),_vm._v(" "),(!_vm.instance.hasValue && !_vm.instance.searchQuery)?_c('placeholder',{key:"placeholer"}):_vm._e(),_vm._v(" "),_c('search-input',{key:"input",ref:"input"})],2)],1)}
var MultiValue_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/MultiValue.vue
/* script */


/* template */

/* template functional */
var MultiValue___vue_template_functional__ = false
/* styles */
var MultiValue___vue_styles__ = null
/* scopeId */
var MultiValue___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MultiValue___vue_module_identifier__ = null

var MultiValue_Component = normalizeComponent(
  MultiValue,
  MultiValue_render,
  MultiValue_staticRenderFns,
  MultiValue___vue_template_functional__,
  MultiValue___vue_styles__,
  MultiValue___vue_scopeId__,
  MultiValue___vue_module_identifier__
)

/* harmony default export */ var components_MultiValue = (MultiValue_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SingleValue.vue






/* harmony default export */ var SingleValue = ({
  name: 'vue-treeselect--single-value',
  components: { Placeholder: components_Placeholder, SearchInput: components_SearchInput },
  mixins: [valueMixin],
  inject: ['instance']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e30e4d2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SingleValue.vue
var SingleValue_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-treeselect__value-wrapper"},[(_vm.instance.hasValue && !_vm.instance.searchQuery)?_c('div',{staticClass:"vue-treeselect__single-value"},[_vm._v("\n    "+_vm._s(_vm.instance.selectedNodes[0].label)+"\n  ")]):(!_vm.instance.searchQuery)?_c('placeholder'):_vm._e(),_vm._v(" "),_c('search-input',{key:"input",ref:"input"})],1)}
var SingleValue_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/SingleValue.vue
/* script */


/* template */

/* template functional */
var SingleValue___vue_template_functional__ = false
/* styles */
var SingleValue___vue_styles__ = null
/* scopeId */
var SingleValue___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SingleValue___vue_module_identifier__ = null

var SingleValue_Component = normalizeComponent(
  SingleValue,
  SingleValue_render,
  SingleValue_staticRenderFns,
  SingleValue___vue_template_functional__,
  SingleValue___vue_styles__,
  SingleValue___vue_scopeId__,
  SingleValue___vue_module_identifier__
)

/* harmony default export */ var components_SingleValue = (SingleValue_Component.exports);

// CONCATENATED MODULE: ./src/mixins/optionMixin.js


/* harmony default export */ var optionMixin = ({
  props: {
    node: {
      type: Object,
      required: true
    }
  },

  computed: {
    checkedState: function checkedState() {
      return this.instance.nodeCheckedStateMap[this.node.id];
    },
    shouldExpand: function shouldExpand() {
      if (!this.node.isBranch) return false;
      return this.instance.searching ? this.node.expandsOnSearch : this.node.isExpanded;
    },
    shouldShowCount: function shouldShowCount() {
      if (!this.node.isBranch) return false;
      return this.instance.searching ? this.instance.showCountOnSearchComputed : this.instance.showCount;
    },
    count: function count() {
      if (!this.shouldShowCount) return NaN;
      return this.instance.searching ? this.instance.searchingCount[this.node.id][this.instance.showCountOf] : this.node.count[this.instance.showCountOf];
    },
    shouldShowArrorPlaceholder: function shouldShowArrorPlaceholder() {
      if (this.node.isBranch) return false;
      return this.node.isLeaf && this.instance.hasBranchNodes;
    }
  },

  watch: {
    'shouldExpand': function shouldExpand(newValue) {
      if (newValue === true && !this.node.isLoaded) {
        this.instance.loadChildrenOptions(this.node);
      }
    }
  },

  methods: {
    handleMouseDownOnOption: Object(utils["k" /* onlyOnLeftClick */])(function handleMouseDownOnOptionArrow() {
      if (this.node.isBranch && this.instance.disableBranchNodes) {
        this.instance.toggleExpanded(this.node);
      } else {
        this.instance.select(this.node);
      }
    }),

    handleMouseDownOnOptionArrow: Object(utils["k" /* onlyOnLeftClick */])(function handleMouseDownOnOptionArrow() {
      this.instance.toggleExpanded(this.node);
    })
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Tip.vue


/* harmony default export */ var Tip = ({
  name: 'vue-treeselect--tip',
  props: {
    type: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7604db82","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tip.vue
var Tip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("vue-treeselect__" + _vm.type + "-tip")},[_c('div',{staticClass:"vue-treeselect__icon-wrapper"},[_c('span',{class:("vue-treeselect__icon-" + _vm.icon)})]),_vm._v(" "),_c('span',{class:("vue-treeselect__" + _vm.type + "-tip-text")},[_vm._t("default")],2)])}
var Tip_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/Tip.vue
/* script */


/* template */

/* template functional */
var Tip___vue_template_functional__ = false
/* styles */
var Tip___vue_styles__ = null
/* scopeId */
var Tip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Tip___vue_module_identifier__ = null

var Tip_Component = normalizeComponent(
  Tip,
  Tip_render,
  Tip_staticRenderFns,
  Tip___vue_template_functional__,
  Tip___vue_styles__,
  Tip___vue_scopeId__,
  Tip___vue_module_identifier__
)

/* harmony default export */ var components_Tip = (Tip_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Option.vue





/* harmony default export */ var Option = ({
  name: 'vue-treeselect--option',
  inject: ['instance', 'UNCHECKED', 'INDETERMINATE', 'CHECKED'],
  components: { Tip: components_Tip },
  mixins: [optionMixin]
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1802bfc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Option.vue
var Option_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-treeselect__list-item"},[_c('div',{class:[ 'vue-treeselect__option', {
    'vue-treeselect__option--disabled': _vm.node.isDisabled,
    'vue-treeselect__option--root': _vm.node.isRootNode,
    'vue-treeselect__option--child': !_vm.node.isRootNode,
    'vue-treeselect__option--selected': _vm.instance.isSelected(_vm.node),
    'vue-treeselect__option--matched': _vm.instance.searching && _vm.node.isMatched,
    'vue-treeselect__option--hide': _vm.instance.searching && !(_vm.node.isMatched || _vm.node.hasMatchedChild),
  } ]},[(_vm.shouldShowArrorPlaceholder)?_c('div',{staticClass:"vue-treeselect__option-arrow-placeholder"},[_vm._v(" ")]):(_vm.node.isBranch)?_c('div',{staticClass:"vue-treeselect__option-arrow-wrapper",on:{"mousedown":_vm.handleMouseDownOnOptionArrow}},[_c('transition',{attrs:{"name":"vue-treeselect__option-arrow--prepare","appear":""}},[_c('span',{class:[ 'vue-treeselect__option-arrow', {
          'vue-treeselect__option-arrow--rotated': _vm.shouldExpand,
        } ]})])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vue-treeselect__label-wrapper",on:{"mousedown":_vm.handleMouseDownOnOption}},[(_vm.instance.multiple && (!_vm.instance.disableBranchNodes || _vm.node.isLeaf))?_c('div',{staticClass:"vue-treeselect__checkbox-wrapper"},[_c('span',{class:[ 'vue-treeselect__checkbox', {
          'vue-treeselect__checkbox--checked': _vm.checkedState === _vm.CHECKED,
          'vue-treeselect__checkbox--indeterminate': _vm.checkedState === _vm.INDETERMINATE,
          'vue-treeselect__checkbox--unchecked': _vm.checkedState === _vm.UNCHECKED,
          'vue-treeselect__checkbox--disabled': _vm.node.isDisabled,
        } ]},[_c('span',{staticClass:"vue-treeselect__checkbox-mark"})])]):_vm._e(),_vm._v(" "),_vm._t("option-label",null,{node:_vm.node,shouldShowCount:_vm.shouldShowCount,count:_vm.count,labelClassName:"vue-treeselect__label",countClassName:"vue-treeselect__count"})],2)]),_vm._v(" "),(_vm.shouldExpand)?_c('div',{staticClass:"vue-treeselect__list"},[(_vm.node.isLoaded)?[(_vm.node.children.length)?_vm._l((_vm.node.children),function(childNode){return _c('vue-treeselect--option',{key:childNode.id,attrs:{"node":childNode},scopedSlots:_vm._u([{key:"option-label",fn:function(ref){
        var node = ref.node;
        var shouldShowCount = ref.shouldShowCount;
        var count = ref.count;
        var labelClassName = ref.labelClassName;
        var countClassName = ref.countClassName;
return [_vm._t("option-label",null,{node:node,shouldShowCount:shouldShowCount,count:count,labelClassName:labelClassName,countClassName:countClassName})]}}])})}):_c('tip',{attrs:{"type":"no-children","icon":"warning"}},[_vm._v(_vm._s(_vm.instance.noChildrenText))])]:(_vm.node.isPending)?_c('tip',{attrs:{"type":"loading","icon":"loader"}},[_vm._v(_vm._s(_vm.instance.loadingText))]):(_vm.node.loadingChildrenError)?_c('tip',{attrs:{"type":"error","icon":"error"}},[_vm._v("\n      "+_vm._s(_vm.node.loadingChildrenError)+"\n      "),_c('a',{staticClass:"vue-treeselect__retry",attrs:{"title":_vm.instance.retryTitle},on:{"click":function($event){_vm.instance.loadChildrenOptions(_vm.node)}}},[_vm._v("\n        "+_vm._s(_vm.instance.retryText)+"\n      ")])]):_vm._e()],2):_vm._e()])}
var Option_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/Option.vue
/* script */


/* template */

/* template functional */
var Option___vue_template_functional__ = false
/* styles */
var Option___vue_styles__ = null
/* scopeId */
var Option___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Option___vue_module_identifier__ = null

var Option_Component = normalizeComponent(
  Option,
  Option_render,
  Option_staticRenderFns,
  Option___vue_template_functional__,
  Option___vue_styles__,
  Option___vue_scopeId__,
  Option___vue_module_identifier__
)

/* harmony default export */ var components_Option = (Option_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Treeselect.vue









/* harmony default export */ var Treeselect = ({
  name: 'vue-treeselect',
  components: { HiddenField: components_HiddenField, MultiValue: components_MultiValue, SingleValue: components_SingleValue, TreeselectOption: components_Option, Tip: components_Tip },
  mixins: [treeselectMixin]
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eab8114","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Treeselect.vue
var Treeselect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",class:[ 'vue-treeselect', {
    'vue-treeselect--single': _vm.single,
    'vue-treeselect--multi': _vm.multiple,
    'vue-treeselect--searchable': _vm.searchable,
    'vue-treeselect--disabled': _vm.disabled,
    'vue-treeselect--focused': _vm.isFocused,
    'vue-treeselect--has-value': _vm.hasValue,
    'vue-treeselect--open': _vm.isOpen,
    'vue-treeselect--open-above': _vm.prefferedOpenDirection === 'above',
    'vue-treeselect--open-below': _vm.prefferedOpenDirection === 'below',
    'vue-treeselect--branch-nodes-disabled': _vm.disableBranchNodes,
  } ],on:{"mousedown":_vm.handleMouseDown}},[(_vm.name && _vm.hasValue)?[(_vm.single)?_c('HiddenField',{attrs:{"stringified-value":_vm.stringifyValue(_vm.internalValue[0])}}):(_vm.joinValues)?_c('HiddenField',{attrs:{"stringified-value":_vm.internalValue.map(_vm.stringifyValue).join(_vm.delimiter)}}):_vm._l((_vm.internalValue),function(v,i){return _c('HiddenField',{key:i,attrs:{"stringified-value":_vm.stringifyValue(v)}})})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"vue-treeselect__control"},[(_vm.single)?_c('single-value',{ref:"value"}):_c('multi-value',{ref:"value"}),_vm._v(" "),(_vm.shouldShowX)?_c('div',{staticClass:"vue-treeselect__x",attrs:{"title":_vm.multiple ? _vm.clearAllText : _vm.clearValueText},on:{"mousedown":_vm.handleMouseDownOnClear}},[_vm._v("×")]):_vm._e(),_vm._v(" "),(!_vm.isOpen || !_vm.alwaysOpen)?_c('div',{staticClass:"vue-treeselect__arrow-wrapper",on:{"mousedown":_vm.handleMouseDownOnArrow}},[_c('span',{class:[ 'vue-treeselect__arrow', { 'vue-treeselect__arrow--rotated': _vm.isOpen } ]})]):_vm._e()],1),_vm._v(" "),(_vm.isOpen)?_c('div',{ref:"menu",staticClass:"vue-treeselect__menu",style:({ maxHeight: _vm.optimizedHeight + 'px' })},[(_vm.rootOptionsLoaded)?[(_vm.searching && _vm.noSearchResults)?_c('tip',{attrs:{"type":"no-results","icon":"warning"}},[_vm._v(_vm._s(_vm.noResultsText))]):(_vm.normalizedOptions.length === 0)?_c('tip',{attrs:{"type":"no-options","icon":"warning"}},[_vm._v(_vm._s(_vm.noOptionsText))]):_c('div',{staticClass:"vue-treeselect__list"},_vm._l((_vm.normalizedOptions),function(rootNode){return _c('treeselect-option',{key:rootNode.id,attrs:{"node":rootNode},scopedSlots:_vm._u([{key:"option-label",fn:function(ref){
  var node = ref.node;
  var shouldShowCount = ref.shouldShowCount;
  var count = ref.count;
  var labelClassName = ref.labelClassName;
  var countClassName = ref.countClassName;
return [_vm._t("option-label",[_c('label',{class:labelClassName},[_vm._v("\n                "+_vm._s(node.label)+"\n                "),(shouldShowCount)?_c('span',{class:countClassName},[_vm._v("("+_vm._s(count)+")")]):_vm._e()])],{node:node,shouldShowCount:shouldShowCount,count:count,labelClassName:labelClassName,countClassName:countClassName})]}}])})}))]:[(_vm.loading || _vm.loadingRootOptions)?_c('tip',{attrs:{"type":"loading","icon":"loader"}},[_vm._v(_vm._s(_vm.loadingText))]):(_vm.loadingRootOptionsError)?_c('tip',{attrs:{"type":"error","icon":"error"}},[_vm._v("\n        "+_vm._s(_vm.loadingRootOptionsError)+"\n        "),_c('a',{staticClass:"vue-treeselect__retry",attrs:{"title":_vm.retryTitle},on:{"click":_vm.loadRootOptions}},[_vm._v("\n          "+_vm._s(_vm.retryText)+"\n        ")])]):_vm._e()]],2):_vm._e()],2)}
var Treeselect_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/Treeselect.vue
/* script */


/* template */

/* template functional */
var Treeselect___vue_template_functional__ = false
/* styles */
var Treeselect___vue_styles__ = null
/* scopeId */
var Treeselect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Treeselect___vue_module_identifier__ = null

var Treeselect_Component = normalizeComponent(
  Treeselect,
  Treeselect_render,
  Treeselect_staticRenderFns,
  Treeselect___vue_template_functional__,
  Treeselect___vue_styles__,
  Treeselect___vue_scopeId__,
  Treeselect___vue_module_identifier__
)

/* harmony default export */ var components_Treeselect = (Treeselect_Component.exports);

// EXTERNAL MODULE: ./src/style.less
var style = __webpack_require__(5);
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Treeselect", function() { return components_Treeselect; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "treeselectMixin", function() { return treeselectMixin; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "optionMixin", function() { return optionMixin; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "valueMixin", function() { return valueMixin; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOAD_ROOT_OPTIONS", function() { return constants["r" /* LOAD_ROOT_OPTIONS */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOAD_CHILDREN_OPTIONS", function() { return constants["q" /* LOAD_CHILDREN_OPTIONS */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ASYNC_SEARCH", function() { return constants["d" /* ASYNC_SEARCH */]; });







/* harmony default export */ var src = __webpack_exports__["default"] = (components_Treeselect);



/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("fuzzysearch");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
//# sourceMappingURL=vue-treeselect.js.map